import React from 'react';
import ArticleCard from '../components/ArticleCard';
import SEOMetaTags from '../components/SEOMetaTags';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';
import articlesData from '../data/articles.json';

const Blog = () => {
    const { t, language } = useLanguage();
    usePageTitle('blog');

    return (
        <>
            <SEOMetaTags pageKey="blog" />
            {/* Section - Inner Page Headline Start */}
            <div className="mxd-section mxd-section-inner-headline padding-blog-default-pre-grid">
                <div className="mxd-container grid-container">
                    {/* Block - Inner Page Headline Start */}
                    <div className="mxd-block loading-wrap">
                        <div className="container-fluid px-0">
                            <div className="row gx-0">
                                {/* Inner Headline Name Start */}
                                <div className="col-12"></div>
                                {/* Inner Headline Name End */}

                                {/* Inner Headline Content Start */}
                                <div className="col-12 col-xl-10 mxd-grid-item no-margin">
                                    <div className="mxd-block__content">
                                        <div className="mxd-block__inner-headline loading__item">
                                            <h1 className="inner-headline__title">
                                                {t('blog.hero.title')}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                                {/* Inner Headline Content End */}

                                {/* Inner Headline Aside Start */}
                                <div className="col-12"></div>
                                {/* Inner Headline Aside End */}
                            </div>

                            <div className="row g-0">
                                <div className="col-12"></div>

                                {/* Inner Headline Description Start */}
                                <div className="col-12 col-xl-8 mxd-grid-item no-margin">
                                    <div className="inner-headline__text loading__item">
                                        <p className="t-large t-bright">
                                            {t('blog.hero.description')}
                                        </p>
                                    </div>
                                </div>
                                {/* Inner Headline Description End */}
                            </div>
                        </div>
                    </div>
                    {/* Block - Inner Page Headline End */}
                </div>
            </div>
            {/* Section - Inner Page Headline End */}

            {/* Section - Blog Start */}
            <div className="mxd-section padding-default">
                <div className="mxd-container grid-container">
                    <div className="mxd-block">
                        <div className="container-fluid px-0">
                            <div className="row gx-5 gy-5">
                                {articlesData.length > 0 ? (
                                    articlesData.map((article) => (
                                        <ArticleCard key={article.id} article={article} />
                                    ))
                                ) : (
                                    <div className="col-12">
                                        <div className="mxd-empty-state anim-uni-in-up" style={{ textAlign: 'center', padding: '4rem 0' }}>
                                            <i className="ph-bold ph-article" style={{ fontSize: '4rem', opacity: 0.3 }}></i>
                                            <p className="t-large" style={{ marginTop: '1rem', opacity: 0.6 }}>
                                                {t('blog.no_articles')}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Section - Blog End */}
        </>
    );
};

export default Blog;